import { render, staticRenderFns } from "./DlgEventEdit.vue?vue&type=template&id=3cfe0c6a&scoped=true&"
import script from "./DlgEventEdit.vue?vue&type=script&lang=ts&"
export * from "./DlgEventEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfe0c6a",
  null
  
)

export default component.exports